module.exports = __webpack_public_path__ + "img/copy-linear.887acf8c.svg";